<template>
	<div id="gamePageFrame">
			<iframe allowfullscreen="true" allow="autoplay" :src="url" :style="{ width: gameWidth + 'px', height: gameHeight + 'px', transform: 'scale(' + scaleValue + ')' }" />
	</div>
</template>

<style scoped>
#gamePageFrame {
	padding: 0 !important;
	background-color: #273143;
	text-align: center;
}

iframe {
	border: none;
	transform-origin: top left;
}
</style>

<script>
export default {
	data() {
		return {
			scaleValue: 1,
			gameHeight: 720,
			gameWidth: 854,
		};
	},
	mounted() {
		this.scaleTo();
		window.addEventListener('resize', this.scaleTo);
	},
	beforeDestroy () {
		window.removeEventListener("resize", this.scaleTo);
	},
	computed: {
		url () {
			return 'https://classic.webhallen.com/medlem-popup/game/';
		},
	},
	methods: {
		scaleTo() {
			let gamePageWidth = document.getElementById('gamePageFrame').offsetWidth;
			let newScale = this.scaleValue;
			if (gamePageWidth < this.gameWidth) {
				newScale = Math.floor(gamePageWidth/this.gameWidth * 1000)/1000;
			}
			if (newScale !== this.scaleValue && newScale <= 1) {
				this.scaleValue = newScale;
			}
		},
	},
};
</script>
